import { useEffect, lazy, Suspense } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { checkAuth } from "./store/authSlice"
import { Layout } from "./components/Layout"
import { selectSize } from "./store/handlingSlice"

const LoginPage = lazy(() => import("./pages/LoginPage/LoginPage"))
const DashboardPage = lazy(() => import("./pages/DashboardPage/DashboardPage"))
const SitesPage = lazy(() => import("./pages/SitesPage/SitesPage"))
const BuilderPage = lazy(() => import("./pages/BuilderPage/BuilderPage"))
const UsersPage = lazy(() => import("./pages/UsersPage/UsersPage"))

function PrivateRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
  const isLoading = useSelector((state) => state.auth.isLoading)

  if (isLoading) {
    return (
      <div className="loading-screen">
      </div>
    )
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />
}

function App() {
  const dispatch = useDispatch()
  const size = useSelector(selectSize)

  useEffect(() => {
    const theme = localStorage.getItem("theme")
    if (theme) {
      document.documentElement.classList.add(theme)
    }
  }, [])

  useEffect(() => {
    dispatch(checkAuth())
  }, [dispatch])

  return (
    <Suspense fallback={""}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="sites/:siteId/builder" element={<BuilderPage />} />
          <Route path="users" element={<UsersPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}

export default App
